const _registeredLayouts = {};
export function getRegisteredLayouts() {
    return _registeredLayouts;
}
export function hasRegisteredLayout(name) {
    return _registeredLayouts.hasOwnProperty(name);
}
export function addRegisteredLayout(registeredLayout) {
    // if (_registeredLayouts[registeredLayout.name]) {
    // 	console.warn(
    // 		`_registeredLayouts already contain a layout named ${
    // 			registeredLayout.name
    // 		}, will override`
    // 	);
    // }
    _registeredLayouts[registeredLayout.name] = registeredLayout;
}
//# sourceMappingURL=layoutDescriptions.js.map